import React from 'react';

type Props = {
  className?: string;
  width?: string;
  height?: string;
  fill?: string;
};

const Exclamation3: React.FC<Props> = ({ className, width = '23', height = '23', fill = '#E9314A' }) => (
  <svg className={className} width={width} height={height} viewBox="0 0 23 23" fill="none">
    <path d="M6.8425 0H16.1575L22.75 5.86V14.14L16.1575 20H6.8425L0.25 14.14V5.86L6.8425 0Z" fill={fill} />
  </svg>
);

export default Exclamation3;
